const saleOneYear = [
  {
    value: '0',
    key: '0-10万美金'
  },
  {
    value: '1',
    key: '10万到100万美金'
  },
  {
    value: '2',
    key: '100万到1000万美金'
  },
  {
    value: '3',
    key: '1000万到1亿美金'
  },
  {
    value: '4',
    key: '1亿以上美金'
  }
]
export default saleOneYear
